<template>
  <div>

    <HeroBanner
      heading="Need some support?"
      subheading="Find answers to frequently asked questions and guided videos for Agents, Buyers and Sellers on PFX."
      theme="faq"
      :buttons="[]"
    />

    <div class="container" style="margin: 0 auto;">
      <h1 class="above-menu">Help Centre</h1>
      <nav>
        <ul>
          <router-link tag="li" to="/faq/agents">Agents</router-link>
          <router-link tag="li" to="/faq/buyers">Buyers</router-link>
          <router-link tag="li" to="/faq/sellers">Sellers</router-link>
        </ul>
      </nav>
    </div>

  </div>
</template>

<script>
  import HeroBanner from './elements/HeroBanner.vue'

  export default {
    name: 'FaqMenu',
    components: {
      HeroBanner
    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  h1 {
    font-family: 'Encode Sans', sans-serif;
    font-size: 24px;
    font-weight: 600;
    margin: 2rem 0 1rem;
  }

  nav {
    margin: 1rem 0 2rem;
    border-bottom: 1px solid #eee;

    li {
      @include tablet-portrait-breakpoint {
        display: inline-block;
        min-width: 100px;
        text-align: center;
      }

      padding: 0.5rem 0;
      cursor: pointer;
      font-family: 'Encode Sans', sans-serif;
      font-size: 16px;
      color: #b3b3b3;
    }
    li.router-link-active {
      font-weight: 600;
      color: inherit;
      border-bottom: 2px solid $color-pfx-brand;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/FaqMenu.vue